export enum ACTIVE_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
